/* eslint-disable */
import Oidc from 'oidc-client';
import 'babel-polyfill';
import utility from "@/plugins/utility";


var isLocal = location.hostname === "localhost" || location.hostname === "127.0.0.1"
var config = {
	userStore: new Oidc.WebStorageStateStore(),
	authority: 'https://ssonicard.eniac-tech.com/',
	client_id: 'A72946C9-6256-4C1A-8E45-62FECD789351',
	client_secret: '86V%#L5UMdX3spke3ctL$1o5YHjU73N',
	redirect_uri: window.location.origin + '/auth/signin-oidc',
	response_type: 'code',
	response_mode: 'query',
	scope: 'openid profile FullAccess roles Infos UserNames',
	post_logout_redirect_uri: window.location.origin,
	//silent_redirect_uri: window.location.origin + '/auth/silent-renew',
	automaticSilentRenew: false,
	filterProtocolClaims: true,
	loadUserInfo: true
};

if (isLocal)
{
	config.client_id = '4BA800BA-061F-4E1D-BF40-3A746E6FA84C';
	config.client_secret = '123456';
}


var mgr = new Oidc.UserManager(config)

//Oidc.Log.logger = console;
//Oidc.Log.level = Oidc.Log.INFO;

mgr.events.addUserLoaded(function (user)
{
	//console.log('New User Loaded：', arguments);
	//console.log('Acess_token: ', user.access_token)
});

mgr.events.addAccessTokenExpiring(function ()
{
	//console.log('AccessToken Expiring：', arguments);
});

mgr.events.addAccessTokenExpired(function ()
{
	mgr.signinSilent().then(function (resp)
    {
		//console.log('signin Silent', resp);
    }).catch(function (err)
    {
		//console.log('signin Silent error', err)
    })
});

mgr.events.addSilentRenewError(function ()
{
	//console.error('Silent Renew Error：', arguments);
});

mgr.events.addUserSignedOut(function ()
{
	localStorage.clear()
});

export default class SecurityService
{

	// Renew the token manually
	renewToken()
	{
		let self = this
		return new Promise((resolve, reject) =>
		{
			mgr.signinSilent().then(function (user)
			{
				if (user == null)
				{
					self.signIn(null)
				} else
				{
					return resolve(user)
				}
			}).catch(function (err)
			{
				console.log(err)
				return reject(err)
			});
		})
	}

	// Get the user who is logged in
	getUser()
	{
		let self = this
		return new Promise((resolve, reject) =>
		{
			mgr.getUser().then(function (user)
			{
				if (user == null)
				{
					self.signIn()
					return resolve(null)
				} else
				{
					return resolve(user)
				}
			}).catch(function (err)
			{
				console.log(err)
				return reject(err)
			});
		})
	}

	getUserWithoutSignin()
	{
		return new Promise((resolve, reject) =>
		{
			mgr.getUser().then(function (user)
			{
				if (user == null)
				{
					return resolve(null)
				} else
				{
					return resolve(user)
				}
			}).catch(function (err)
			{
				return reject(err)
			});
		})
	}


	// Check if there is any user logged in
	getSignedIn()
	{
		let self = this
		return new Promise((resolve, reject) =>
		{
			mgr.getUser().then(function (user)
			{
				if (user == null)
				{
					self.signIn()
					return resolve(false)
				} else
				{
					return resolve(true)
				}
			}).catch(function (err)
			{
				console.log(err)
				return reject(err)
			});
		})
	}

	// Redirect of the current window to the authorization endpoint.
	signIn()
	{
		mgr.signinRedirect().catch(function (err)
		{
			console.log(err)
		})
	}

	// Redirect of the current window to the end session endpoint
	signOut()
	{
		mgr.signoutRedirect().then(function (resp)
		{
			console.log('signed out', resp);
		}).catch(function (err)
		{
			console.log(err)
		})
	}

	// Get the profile of the user logged in
	getProfile()
	{
		let self = this
		return new Promise((resolve, reject) =>
		{
			mgr.getUser().then(function (user)
			{
				if (user == null)
				{
					self.signIn()
					return resolve(null)
				} else
				{
					return resolve(user.profile)
				}
			}).catch(function (err)
			{
				console.log(err)
				return reject(err)
			});
		})
	}

	// Get the token id
	getIdToken()
	{
		let self = this
		return new Promise((resolve, reject) =>
		{
			mgr.getUser().then(function (user)
			{
				if (user == null)
				{
					self.signIn()
					return resolve(null)
				} else
				{
					return resolve(user.id_token)
				}
			}).catch(function (err)
			{
				console.log(err)
				return reject(err)
			});
		})
	}

	// Get the session state
	getSessionState()
	{
		let self = this
		return new Promise((resolve, reject) =>
		{
			mgr.getUser().then(function (user)
			{
				if (user == null)
				{
					self.signIn()
					return resolve(null)
				} else
				{
					return resolve(user.session_state)
				}
			}).catch(function (err)
			{
				console.log(err)
				return reject(err)
			});
		})
	}

	// Get the access token of the logged in user
	getAcessToken()
	{
		let self = this
		return new Promise((resolve, reject) =>
		{
			mgr.getUser().then(function (user)
			{
				if (user == null)
				{
					self.signIn()
					return resolve(null)
				} else
				{
					return resolve(user.access_token)
				}
			}).catch(function (err)
			{
				console.log(err)
				return reject(err)
			});
		})
	}

	// Takes the scopes of the logged in user
	getScopes()
	{
		let self = this
		return new Promise((resolve, reject) =>
		{
			mgr.getUser().then(function (user)
			{
				if (user == null)
				{
					self.signIn()
					return resolve(null)
				} else
				{
					return resolve(user.scopes)
				}
			}).catch(function (err)
			{
				console.log(err)
				return reject(err)
			});
		})
	}

	// Get the user roles logged in
	getRole()
	{
		let self = this
		return new Promise((resolve, reject) =>
		{
			mgr.getUser().then(function (user)
			{
				if (user == null)
				{
					self.signIn()
					return resolve(null)
				} else
				{
					return resolve(user.profile.role)
				}
			}).catch(function (err)
			{
				console.log(err)
				return reject(err)
			});
		})
	}
}
